module.exports = __webpack_public_path__ + "static/img/NP.62fb43b0.png";